export const formatCurrency = val => {
    if (val) {
      return new Intl.NumberFormat('en-IN', {currency: 'INR'}).format(val);
    } else {
      return 0;
    }
  };